/**
 * Keywords AI Constants
 * 
 * Shared constants for Keywords AI integration.
 */

/**
 * Keywords AI API base URL
 */
export const KEYWORDS_API_BASE = 'https://api.keywordsai.co/api';

/**
 * Cache TTL for prompts (15 minutes)
 * Matches the background sync interval for consistency
 */
export const KEYWORDS_CACHE_TTL = 15 * 60 * 1000;

/**
 * Fetch timeout for Keywords AI requests (2 minutes)
 */
export const KEYWORDS_FETCH_TIMEOUT = 120000;
